'use strict'
const elementorySupport = require('@wix/wix-code-platform/dist/elementory-browser-support.min.js')
const {
  fetchUserCode: _fetchUserCode,
  fetchUserCodeAsync: _fetchUserCodeAsync,
  startUserCode: _startUserCode
} = require('./userCodeHandler')
const workerLogger = require('./workerLogger')
const { setElementoryArguments } = require('./elementoryArgumentsHandler')

function create({ appLogger }) {
  let onLog = () => {
    throw new Error('onLog was used before it was created')
  }

  function wixCodeBootstrap(
    consoleInstance,
    sendCallback,
    { viewMode: _viewMode } = {}
  ) {
    appLogger.init({
      // TODO: add user once we have the wixSdk
      // user: {
      //   id: get_(wixSdk, ['user', 'currentUser', 'id'])
      // },
      viewMode: _viewMode
    })

    try {
      onLog = workerLogger.wrapConsole(consoleInstance)
      onLog(sendCallback) // TODO: forward logs only in preview mode

      self.elementorySupport = elementorySupport

      // This script defines `self.require` function which handles loading namespaces
      // (routes "import wl from 'wix-location'" to self['wix-location']).
      // Our app (this entire artifact) is loaded using a utility in the platform which
      // also defines temporarily (only during the import of the script) a `self.require` function.
      // If we would require this script at the top level (with all other scripts) it would
      // clash with the platform `self.require`. As a temporary solution, we load it here,
      // where it cannot override any existing function.
      // The correct solution will be to rewrite this script in a way that doesn't do side effects,
      // and returns the custom `require` function for us to put on `self` whenever we want.
      require('@wix/wix-code-platform/dist/scoped-all.min.js')
    } catch (e) {
      appLogger.error(e)
      throw e
    }
  }

  function updateWixCodeData({ elementoryArguments }) {
    try {
      if (elementoryArguments) {
        appLogger.addSessionData(() => ({ elementoryArguments }))

        setElementoryArguments(elementoryArguments)
      }
    } catch (e) {
      appLogger.error(e)
      throw e
    }
  }

  function startUserCode(
    wixCodeScripts,
    { elementoryArguments, routerData } = {}
  ) {
    try {
      appLogger.addSessionData(() => ({ elementoryArguments, routerData }))

      const wixSdk = {
        location: self['wix-location'],
        users: self['wix-users'],
        window: self['wix-window'],
        site: self['wix-site']
      }

      return _startUserCode({
        appLogger,
        wixSdk,
        wixCodeScripts,
        elementoryArguments,
        routerData,
        onLog
      })
    } catch (e) {
      appLogger.error(e)
      throw e
    }
  }

  function fetchUserCode(wixCodeScripts, importScriptFunc, extraData) {
    try {
      return _fetchUserCode(wixCodeScripts, importScriptFunc, extraData)
    } catch (e) {
      appLogger.error(e)
      throw e
    }
  }

  function fetchUserCodeAsync(wixCodeScripts, loadAmdFunc, extraData) {
    try {
      return _fetchUserCodeAsync(
        appLogger,
        wixCodeScripts,
        loadAmdFunc,
        extraData
      )
    } catch (e) {
      appLogger.error(e)
      throw e
    }
  }

  return {
    fetchUserCode,
    fetchUserCodeAsync,
    startUserCode,
    wixCodeBootstrap,
    updateWixCodeData
  }
}

module.exports.create = create
